import React from 'react';
import { useAtomValue } from '@exodus/headless-ui';
import { fromAssetAtom, fromTotalBalanceAtom } from '../../../atoms/index.js';
const AssetLabel = ({ Component, className, style }) => {
    const fromAsset = useAtomValue(fromAssetAtom);
    const fromTotalBalance = useAtomValue(fromTotalBalanceAtom);
    if (Component) {
        return (React.createElement(Component, { side: "from", asset: fromAsset, balance: fromTotalBalance, className: className, style: style }));
    }
    return null;
};
export default AssetLabel;
